import { FilterableEngagementField, UserQueryResult } from 'graphql/generated'
import React, { useMemo, useState } from 'react'
import { useIsLoggedIn } from 'hooks'
import { ProfileBaseInfo } from './ProfileBaseInfo'
import { EventsFeed, FeedTypes } from './EventsFeed'
import language from 'services/Language'
import Typography from 'components/common/Typography'
import ContentWrapper from 'components/ContentWrapper'

interface IProps {
  user: NonNullable<UserQueryResult['user']>
}

const Profile: React.FC<IProps> = ({ user }) => {
  const isLoggedIn = useIsLoggedIn()

  const [showHost, setShowHost] = useState(true)
  const [showSpeaker, setShowSpeaker] = useState(true)

  const typesToShow = useMemo(() => {
    const newTypes: FeedTypes = []

    if (showHost) {
      newTypes.push(FilterableEngagementField.HOSTED)
    }
    if (showSpeaker) {
      newTypes.push(FilterableEngagementField.SPOKE_AT)
    }

    return newTypes
  }, [showHost, showSpeaker])

  const handleHost = event => {
    setShowHost(event.target.checked)
    if (!showSpeaker) {
      setShowSpeaker(true)
    }
  }

  const handleSpeaker = event => {
    setShowSpeaker(event.target.checked)
    if (!showHost) {
      setShowHost(true)
    }
  }

  return (
    <ContentWrapper>
      <div className="px-2 pt-4">
        <ProfileBaseInfo user={user} showViewProfileButton={false} />
      </div>

      {isLoggedIn && (
        <>
          <div className="bg-white py-4 border-b border-gray-100">
            <div className="mx-4 flex justify-end mx-1 space-x-4 items-center">
              <div className="flex space-x-1 items-center">
                <Typography size="sm">
                  {language.profile.hostedEvents}:
                </Typography>
                <input
                  type="checkbox"
                  checked={showHost}
                  onChange={handleHost}
                />
              </div>
              <div className="flex space-x-1 items-center">
                <Typography size="sm">{language.profile.spokeAt}:</Typography>
                <input
                  type="checkbox"
                  checked={showSpeaker}
                  onChange={handleSpeaker}
                />
              </div>
            </div>
          </div>

          <div className="mx-2 mt-2">
            <EventsFeed profileId={user.id} type={typesToShow} />
          </div>
        </>
      )}
    </ContentWrapper>
  )
}

export default Profile
